import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { AdministrationService } from '../../../services/administration.service'
import { WMSValidators } from '../../../shared/validators';

@Component({
    selector: 'dialog-edit-fare',
    templateUrl: 'dialog.editfare.html',
    styleUrls: ['./dialog.editfare.css']
})
export class EditFareDialog implements OnInit, OnDestroy {
    allSub: Subscription[] = [];
    editFareform: FormGroup;
    loading: boolean = false;
    errorMessage: string = '';
    statusList = this.data.StatusList;

    constructor(public dialogRef: MatDialogRef<EditFareDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private administrationService: AdministrationService,
        public snackBar: MatSnackBar) { }

    ngOnInit() {
        this.editFareform = new FormGroup({
            departureStation: new FormControl({ value: this.data.DepartureStation, disabled: true }),
            arrivalStation: new FormControl({ value: this.data.ArrivalStation, disabled: true }),
            baseFare: new FormControl({ value: this.data.BaseFare, disabled: true }),
            airportTax: new FormControl({ value: this.data.AirPortTax, disabled: true }),
            fuelSurcharge: new FormControl({ value: this.data.FuelSurcharge, disabled: true }),
            totalPayment: new FormControl({ value: this.data.PymntAmt, disabled: true }),
            commenceDate: new FormControl({ value: this.data.CommenceDate, disabled: true }),
            fareStatus: new FormControl({
                value: this.statusList.find((element) => {
                    return (element.Status === this.data.Status);
                }).StatusCode, disabled: false
            })
        });
    }

    statusOnChange(e) {
    }

    onSubmit(form: FormGroup) {
        let cfm = confirm("Are you sure you want to save the changes?");

        if (cfm) {
            this.loading = true;
            let fareDetail = {
                DepartureStation: this.editFareform.get('departureStation')!.value,
                ArrivalStation: this.editFareform.get('arrivalStation')!.value,
                CommenceDate: this.editFareform.get('commenceDate')!.value,
                FareStatusCode: this.editFareform.get('fareStatus')!.value,
                UserName: ''
            }

            let save_sub = this.administrationService.updateFareDetails(fareDetail)
                .subscribe(
                    (value) => {
                        if (value.status === 204) {

                        } else if (value.status === 200) {
                            this.loading = false;
                            this.dialogRef.close('Edit successful');
                        } else {
                            this.openSnackBar('Error edit fare list.', '');
                        }
                    },
                    (error) => {
                        this.errorMessage = <any>error;
                        this.openSnackBar(this.errorMessage, '');
                    });

            //Adds into array for each subscribe
            this.allSub.push(save_sub);
        } else {
            this.loading = false;
        }
    }

    ngOnDestroy() {
        for (let sub of this.allSub) {
            sub.unsubscribe();
        }
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
        });
    }
}